// ExamplePage.tsx
import React from "react";
import PetInsuranceTopicsList from "./PET-Insurance-topic-list";
import { PetInsuranceTopics_v02 } from "./PET-Insurance-strings_v02"; // your TS object

export const PET_Insurance_TOPICS_Page_Example_v01: React.FC = () => {
  return (
    <div style={{ background: "#f8f9fa" }}>
      <PetInsuranceTopicsList
        title="Pet Insurance — Features & Benefits"
        topics={PetInsuranceTopics_v02}
        columns={2}         // try 1 or 3 as well
        imageHeightPx={200} // optional
      />
    </div>
  );
};

export default PET_Insurance_TOPICS_Page_Example_v01;
